export const LANG = "LANG";

export function changeLang(name) {
    return { type: LANG, name };
}
